<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.mapManager.pageHeader') }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row
      class="mb-0 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1"
    >
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" lg="5" md="5">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
          >
            <v-row class="pt-0 pb-0 mt-0 mb-2">
              <v-col cols="12" lg="6" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MAP_NAME"
                  @keyup.enter="queryList"
                  :label="$t('lbl.common.conditionSearch.findbyMapperName')"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" class="pt-0 pb-0">
                <v-select
                  v-model="masterSearchItems.data[0].CONV_TP"
                  @change="this.queryList"
                  :items="this.codeItem"
                  :label="$t('lbl.common.conditionSearch.selectType')"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
              <v-col cols="12" lg="3" md="4" class="pt-0 pb-0 pr-24px">
                <v-select
                  v-model="masterSearchItems.data[0].LOCK_YN"
                  @change="this.queryList"
                  :items="this.lockedItems"
                  :label="$t('lbl.common.conditionSearch.selectLocked')"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="7" md="7">
        <v-row>
          <v-col
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1 text-right"
            cols="12"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                v-model="fromdate_menu"
                :close-on-content-click="false"
                ref="fromdate_menu"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.FR_DAT"
                  @input="
                    fromdate_menu = false;
                    changeDate('from');
                  "
                  :max="getMaxDate"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn @click="fromdate_menu = false" text color="primary">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)"
                    text
                    color="primary"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                v-model="todate_menu"
                :close-on-content-click="false"
                ref="todate_menu"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.TO_DAT"
                  @input="
                    todate_menu = false;
                    changeDate('to');
                  "
                  :allowed-dates="allowedDates"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn @click="todate_menu = false" color="primary" text>{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)"
                    color="primary"
                    text
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-autocomplete
                v-model="masterSearchItems.init.DAT_TYPE"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :items="dateTypes"
                :menu-props="{ offsetY: true }"
                @change="changeDtTp"
                class="custom-selectbox"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                class="btn btn-top btn-search btn-width-1"
                color="primary"
                @click.native="queryList"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn class="btn btn-add" @click="openAddMapDialog" :disabled="!$auth.manage">
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  @change="onFilterFlatFile"
                  :items="searchByItems"
                  placeholder="Search by"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" lg="7" md="7">
                <v-text-field
                  v-model="search"
                  @input="onFilterFlatFile"
                  @click:append="onFilterFlatFile"
                  @keyup.enter="onFilterFlatFile"
                  placeholder="Enter search text"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-table
          ref="srm_list_table"
          :height="tableHeight"
          :title-rows="titleRows"
          :columns="columns"
          :table-data="mapList"
          :title-row-height="$vuetify.theme.dark ? 45 : 41"
          :row-height="35"
          :class="
            $vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table repo-list-table custom-figma-1'
              : 'v-search-list-table-merge srm-list-table repo-list-table border-top'
          "
          :errorContent="'No matching records found'"
          :border-header-height="$vuetify.theme.dark ? 0 : 4"
          is-horizontal-resize
          is-vertical-resize
          width="100%"
          :paging-index="(page - 1) * itemsPerPage"
          :multiple-sort="false"
          @sort-change="sortChange"
          @click-overlay="closeTbOverlay"
          :row-click="rowClick"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
        >
          <template v-slot:INDEX="{ item }">
            <div class="index-col">{{ item.ROWID }}</div>
          </template>
          <template v-slot:MAP_NAME="{ item }" class="type-col">
            <div class="pl-2 col-name">{{ item.MAP_NAME }}</div>
          </template>
          <template v-slot:MAPPER_NAME="{ item }" class="type-col">
            <div class="pl-2">{{ item.MAPPER_NAME }}</div>
          </template>
          <template v-slot:SCANNER_NAME="{ item }" class="type-col">
            <div class="pl-2">{{ item.SCANNER_NAME }}</div>
          </template>
          <template v-slot:FFL_FILE_NAME="{ item }" class="type-col">
            <div class="pl-2">{{ item.FFL_FILE_NAME }}</div>
          </template>
          <template v-slot:MPD_FILE_NAME="{ item }" class="type-col">
            <div class="pl-2">{{ item.MPD_FILE_NAME }}</div>
          </template>
          <template v-slot:MST_CUST_NM="{ item }" class="type-col">
            <div class="pl-2">{{ item.MST_CUST_NM }}</div>
          </template>
          <template v-slot:MAP_MAPP_CHKIN_YN="{ item }" class="locked-col">
            <v-icon
              v-if="item.MAP_MAPP_CHKIN_YN === 'Y'"
              :disabled="!$auth.manage"
              @click.native="releaseLockedMap(item, 'MAPP')"
              small
              >fas fa-check-square</v-icon
            >
            <v-icon v-if="item.MAP_MAPP_CHKIN_YN === 'N'" small>far fa-window-close</v-icon>
          </template>
          <template v-slot:MAPP_VER="{ item }" class="type-col text-center">
            <div v-if="!$auth.manage">{{ item.MAPP_VER }}</div>
            <a v-else class="link-file-text" @click="openMapperVersion(item)">
              {{ item.MAPP_VER }}
            </a>
          </template>
          <template v-slot:MAP_SCAN_CHKIN_YN="{ item }" class="locked-col">
            <v-icon
              v-if="item.MAP_SCAN_CHKIN_YN === 'Y'"
              :disabled="!$auth.manage"
              @click.native="releaseLockedMap(item, 'SCAN')"
              small
              >fas fa-check-square</v-icon
            >
            <v-icon v-if="item.MAP_SCAN_CHKIN_YN === 'N'" small>far fa-window-close</v-icon>
          </template>
          <template v-slot:SCAN_VER="{ item }" class="type-col text-center">
            <div v-if="!$auth.manage">{{ item.SCAN_VER }}</div>
            <a
              v-else
              class="link-file-text"
              @click="openScannerResetVersion(item)"
              :disabled="!$auth.manage"
            >
              {{ item.SCAN_VER }}
            </a>
          </template>
          <template v-slot:CNT="{ item }" class="type-col text-center">
            <a class="link-file-text" @click.stop="showSRMList(item, $event)">{{ item.CNT }}</a>
            <v-overlay
              :absolute="absolute"
              :value="overlay"
              :dark="$vuetify.theme.dark"
              class="tableOverlay"
            >
              <v-data-table
                :headers="overlayTableHeader"
                :items="srmData"
                :hide-default-footer="true"
                :disable-sort="true"
                :hide-default-header="true"
                class="overlay-table"
              >
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr @click.stop="closeTbOverlay">
                      <th class="center">{{ headers[0].text }}</th>
                      <th class="center">{{ headers[1].text }}</th>
                      <th class="center">{{ headers[2].text }}</th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id" @click.stop="closeTbOverlay">
                      <td class="sender-col">{{ item.SRM_SNDR }}</td>
                      <td class="receiver-col">{{ item.SRM_RCVR }}</td>
                      <td class="message-col">{{ item.SRM_MSG_ID }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-overlay>
          </template>
          <template v-slot:MANAGE="{ item }">
            <v-btn small text icon @click="openModifyMapDialog(item)" :disabled="!$auth.manage">
              <icon-svg :disabled="!$auth.manage" iconName="edit" />
            </v-btn>
            <v-btn small text icon @click="deleteMapper(item)" :disabled="!$auth.manage">
              <icon-svg :disabled="!$auth.manage" iconName="delete" />
            </v-btn>
          </template>
          <template v-slot:UPD_DT="{ item }" class="date-col text-center">
            <font>{{ item.UPD_DT }}</font>
          </template>
          <template v-slot:MAP_UPD_USR="{ item }">
            <font class="pl-2">{{ item.MAP_UPD_USR }}</font>
          </template>
        </v-table>
      </v-col>
    </v-row>
    <v-row v-show="mapListSource.length > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    @change="pageSizeChange"
                    :items="itemShow"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{
                      mapListSource.length - itemsPerPage * page > 0
                        ? itemsPerPage * page
                        : mapListSource.length
                    }}
                    of {{ mapListSource.length }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="
                    page = 1;
                    setDataPaging();
                  "
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="
                    page = pageCount;
                    setDataPaging();
                  "
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <mapper-version-dialog
        v-if="dialog.type == 'mapperVersion'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="queryList"
        :dialogCheckIn="openFlatFileLayoutCheckIn"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></mapper-version-dialog>

      <mapper-check-in-dialog
        v-if="dialog.type == 'mapperCheckIn'"
        @openLoadFile="openLoadFile($event)"
        @openCodeTableDialog="openCodeTableDialog($event)"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="queryList"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
        ref="mapperCheckIn"
      ></mapper-check-in-dialog>

      <scanner-version-dialog
        v-if="dialog.type == 'scannerVersion'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="queryList"
        :dialogCheckIn="openScannerLayoutCheckIn"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></scanner-version-dialog>

      <scanner-check-in-dialog
        v-if="dialog.type == 'scannerCheckIn'"
        @openLoadFile="openLoadFile($event)"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="queryList"
        :versionList="flatFileVersionHistoryItem"
        :options="dialog.options"
        class="custom-dialog mapper-version"
      ></scanner-check-in-dialog>

      <AddMapLayout
        v-if="dialog.type == 'addMapLayout'"
        @search="queryList"
        @openMappingDefinitionList="openMappingDefinitionList($event)"
        @openFlatFileLayoutList="openFlatFileLayoutList($event)"
        @openLoadFile="openLoadFile($event)"
        @openCodeTableDialog="openCodeTableDialog($event)"
        :id="dialog.id"
        :flatFile="flatFile"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        ref="addMapLayout"
      ></AddMapLayout>

      <flatFile-layout-list-dialog
        v-if="dialog.type == 'flatFileLayoutList'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :selectFile="loadFlatFile"
        :fileSelected="flatFileName"
        :options="dialog.options"
        class="custom-dialog flatfile-layout-list"
      ></flatFile-layout-list-dialog>
      <mappingDefinition-list-dialog
        v-if="dialog.type == 'mappingDefinitionList'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :selectMapFile="loadMappingDefinitionFile"
        :fileSelected="mappingDefinitionFileName"
        :options="dialog.options"
        class="custom-dialog flatfile-layout-list"
      ></mappingDefinition-list-dialog>
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="load-file-dialog"
      ></load-file-dialog>
      <selectCodeList
        v-if="dialog.type == 'selectCodeList'"
        @selectCodeItem="selectCodeItem($event)"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        ref="selectCodeList"
      ></selectCodeList>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="Mapper"
      ></versionHistory>
    </div>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      :detail="$t('msg.common.fromDateValidate')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      title="Delete Map"
      :show-cancel="true"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the selected items'])"
      color="confirmation"
      @select-ok="onDeleteMap"
      @select-close="cancelDeleteMap"
    ></dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :title="$t('msg.common.warning.title')"
      :detail="$t('msg.common.noSelectItem')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="deleteSuccesssDialog"
      size="max"
      title="Delete Success"
      color="success"
      detail="Selected item has been deleted successfully."
      @select-ok="queryList"
    ></dialogWindow>
    <dialogWindow
      ref="warningCheckedOutMapperDialog"
      size="max"
      :detail="
        $t('msg.common.warning.detailWarningReleaseLocked', ['mapper', updateUserId, 'Mapper'])
      "
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningCheckedOutScannerDialog"
      size="max"
      :detail="
        $t('msg.common.warning.detailWarningReleaseLocked', ['scanner', updateUserId, 'Scanner'])
      "
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import mapperVersionDialog from '@/vue-dlb/views/map/MapperVersionHistory.vue';
import mapperCheckInDialog from '@/vue-dlb/views/map/MapperCheckIn.vue';
import scannerVersionDialog from '@/vue-dlb/views/map/ScannerVersionHistory.vue';
import scannerCheckInDialog from '@/vue-dlb/views/map/ScannerCheckIn.vue';
import flatFileLayoutListDialog from '@/vue-dlb/views/srm/FlatfilelayoutList.vue';
import mappingDefinitionListDialog from '@/vue-dlb/views/map/MappingDefinitionList.vue';
import loadFileDialog from '@/vue-dlb/views/mapbuilder/LoadFile.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';

import AddMapLayout from '@/vue-dlb/views/map/AddMapLayout.vue';
import selectCodeList from '@/vue-dlb/views/commons/SelectCodeTable.vue';
import config from '@/vue-caas/config/config.js';
import cfg from '@/vue-caas/config/config.js';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    mapperVersionDialog,
    mapperCheckInDialog,
    scannerCheckInDialog,
    scannerVersionDialog,
    AddMapLayout,
    dialogWindow,
    flatFileLayoutListDialog,
    mappingDefinitionListDialog,
    loadFileDialog,
    selectCodeList,
    SystemProgress,
    versionHistory,
    IconSvg,
  },

  computed: {
    ...mapState('common', {
      bizCodeList: 'bizCodeList',
      codeList: 'codeList',
      repomenuMode: 'repomenuMode',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('map', {
      mapList: 'mapList',
      appliedList: 'appliedList',
      mapListSource: 'mapListSource',
      mapFilterList: 'mapFilterList',
      mapSortList: 'mapSortList',
      mapPagingList: 'mapPagingList',
    }),
    getMaxDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return getAppliedTimeZone();
      } else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate() {
      return this.masterSearchItems.init.FR_DAT;
    },
  },
  data() {
    return {
      tableHeight: 635,
      isCreated: false,
      dateTimeFormat: '',
      ACCESS_REPO_YN: '', // common mandatory for ADMIN_YN
      fromDate: false,
      toDate: false,
      fromdate_menu: false,
      fromdate: null,
      maximumItem: 4,
      todate_menu: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      pageEnter: 1, // 2021.11.24 203728 SPKA-274 modify paging
      search: '',
      flatFile: '',
      flatFileName: '',
      flatFileVersionHistoryItem: null,
      tooltipWidth: 300,
      itemShow: [
        { text: 'Show 10', value: 10 },
        { text: 'Show 25', value: 25 },
        { text: 'Show 50', value: 50 },
        { text: 'Show 75', value: 75 },
        { text: 'Show 100', value: 100 },
      ],
      lockedItems: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'Y', value: 'Y' },
        { text: 'N', value: 'N' },
      ],
      columns: [
        { field: 'INDEX', width: 40, customSlot: true, columnAlign: 'center', isFrozen: true },
        {
          field: 'MAP_NAME',
          width: 300,
          columnAlign: 'left',
          className: 'frozen-col-bg',
          isFrozen: true,
          customSlot: true,
        },
        { field: 'MAP_CONV_TP', width: 72, columnAlign: 'center' },
        { field: 'MAP_MAPP_CHKIN_YN', width: 74, columnAlign: 'center', customSlot: true },
        { field: 'MAPPER_NAME', width: 300, columnAlign: 'left', customSlot: true },
        { field: 'MAPP_VER', width: 110, columnAlign: 'center', customSlot: true },
        { field: 'MAP_SCAN_CHKIN_YN', width: 74, columnAlign: 'center', customSlot: true },
        { field: 'SCANNER_NAME', width: 300, columnAlign: 'left', customSlot: true },
        { field: 'SCAN_VER', width: 110, columnAlign: 'center', customSlot: true },
        { field: 'MANAGE', width: 100, customSlot: true, columnAlign: 'center' },
        {
          field: 'FFL_FILE_NAME',
          width: 239,
          columnAlign: 'left',
          customSlot: true,
          isResize: true,
        },
        { field: 'MPD_FILE_NAME', width: 254, columnAlign: 'left', customSlot: true },
        { field: 'MST_CUST_NM', width: 150, columnAlign: 'left', customSlot: true },
        { field: 'CNT', width: 148, columnAlign: 'center', customSlot: true },
        { field: 'UPD_DT', width: 140, columnAlign: 'center', customSlot: true, isResize: true },
        { field: 'MAP_UPD_USR', width: 200, columnAlign: 'left', customSlot: true, isResize: true },
      ],
      titleRows: [
        [
          { fields: ['INDEX'], title: this.$t('tbl.common.columnNo'), titleAlign: 'center' },
          {
            fields: ['MAP_NAME'],
            title: this.$t('tbl.mapManager.header_mapName'),
            titleAlign: 'center',
            orderBy: '',
            titleCellClassName: 'MAP_NAME',
          },
          {
            fields: ['MAP_CONV_TP'],
            title: this.$t('tbl.mapManager.header_type'),
            titleAlign: 'center',
          },
          {
            fields: ['MAP_MAPP_CHKIN_YN'],
            title: this.$t('tbl.mapManager.header_locked'),
            titleAlign: 'center',
          },
          {
            fields: ['MAPPER_NAME'],
            title: this.$t('tbl.mapManager.header_mapperFileName'),
            titleAlign: 'center',
          },
          {
            fields: ['MAPP_VER'],
            title: this.$t('tbl.mapManager.header_version'),
            titleAlign: 'center',
          },
          {
            fields: ['MAP_SCAN_CHKIN_YN'],
            title: this.$t('tbl.mapManager.header_locked'),
            titleAlign: 'center',
          },
          {
            fields: ['SCANNER_NAME'],
            title: this.$t('tbl.mapManager.header_scannerFileName'),
            titleAlign: 'center',
          },
          {
            fields: ['SCAN_VER'],
            title: this.$t('tbl.mapManager.header_version'),
            titleAlign: 'center',
          },
          {
            fields: ['MANAGE'],
            title: this.$t('tbl.mapManager.header_manage'),
            titleAlign: 'center',
          },
          {
            fields: ['FFL_FILE_NAME'],
            title: this.$t('tbl.mapManager.header_flatfileLayout'),
            titleAlign: 'center',
          },
          {
            fields: ['MPD_FILE_NAME'],
            title: this.$t('tbl.mapManager.header_mappingDefinition'),
            titleAlign: 'center',
          },
          {
            fields: ['MST_CUST_NM'],
            title: this.$t('tbl.mapManager.header_customer'),
            titleAlign: 'center',
          },
          {
            fields: ['CNT'],
            title: this.$t('tbl.mapManager.header_appliedSrm'),
            titleAlign: 'center',
          },
          {
            fields: ['UPD_DT'],
            title: this.$t('tbl.mapManager.header_updateDate'),
            titleAlign: 'center',
            orderBy: 'desc',
            titleCellClassName: 'UPD_DT',
          },
          {
            fields: ['MAP_UPD_USR'],
            title: this.$t('tbl.mapManager.header_updateUser'),
            titleAlign: 'center',
          },
        ],
      ],
      overlayTableHeader: [
        { text: 'Sender', value: 'SRM_SNDR' },
        { text: 'Receiver', value: 'SRM_RCVR' },
        { text: 'Message', value: 'SRM_MSG_ID' },
      ],
      overlay: false,
      absolute: false,
      bizCodeSearchItems: {
        header: ['SVC_DIR'],
        data: [
          {
            SVC_DIR: '',
          },
        ],
      },
      codeSearchItems: {
        header: ['GRP_CODE'],
        data: [
          {
            GRP_CODE: '',
          },
        ],
      },
      masterSearchItems: {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'MAP_NAME',
          'CONV_TP',
          'LOCK_YN',
          'FR_DAT',
          'TO_DAT',
          'DAT_TYPE',
        ],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: `${$cookies.get('comp-id')}`,
            OWNR_CUST_ID: `${$cookies.get('ownr-id')}`,
            MAP_NAME: '',
            CONV_TP: '',
            LOCK_YN: '',
            FR_DAT: '',
            TO_DAT: '',
            DAT_TYPE: '',
          },
        ],
        init: {
          FR_DAT: beforeOneMonth(),
          TO_DAT: getAppliedTimeZone(),
          FR_DAT_PREV: beforeOneMonth(),
          TO_DAT_PREV: getAppliedTimeZone(),
          FR_DAT_ERROR: [],
          TO_DAT_ERROR: [],
          DAT_TYPE: '',
        },
      },
      deleteDataParams: {
        header: ['MAP_PRCS_NO'],
        data: [],
      },
      bizItem: [{ text: 'Business Name', value: '' }],
      codeItem: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      selectMasterRows: [],
      searchBy: 'all',
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Mapper Name', value: 'MAP_NAME' },
        { text: 'Type', value: 'MAP_CONV_TP_NM' },
        { text: 'Mapper File Name', value: 'MAPPER_NAME' },
        { text: 'Mapper Version', value: 'MAPP_VER' },
        { text: 'Scanner Version', value: 'SCAN_VER' },
        { text: 'FlatFile Layout', value: 'FFL_FILE_NAME' },
        { text: 'Mapping Definition', value: 'MPD_FILE_NAME' },
        { text: 'Update Date', value: 'UPD_DT' },
        { text: 'Update User', value: 'MAP_UPD_USR' },
      ],
      releaseLockItems: {
        header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            MAP_KIND: '',
            MAP_PRCS_NO: '',
            LOCK_YN: 'N',
          },
        ],
      },
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      selected: null,
      srmData: [],
      dateTypes: [
        { value: '', text: 'Search by' },
        { value: 'UPDT', text: 'Update Date' },
      ],
      isLoading: true,
      dataSort: {},
      rowCurrentClick: -1,
      rowKey: '',
      listFrozen: [
        'INDEX',
        'MAP_NAME',
        'MAP_CONV_TP',
        'MAP_MAPP_CHKIN_YN',
        'MAPPER_NAME',
        'MAPP_VER',
        'MAP_SCAN_CHKIN_YN',
        'SCANNER_NAME',
        'SCAN_VER',
        'MANAGE',
        'FFL_FILE_NAME',
        'MPD_FILE_NAME',
        'MST_CUST_NM',
        'CNT',
        'UPD_DT',
        'MAP_UPD_USR',
      ],
      currentUserId: '',
      updateUserId: '',
    };
  },
  watch: {
    mapListSource() {
      this.getTableData();
    },
    mapFilterList() {
      this.$nextTick(() => {
        this.pageCount = Math.floor(this.mapFilterList.length / this.itemsPerPage) + 1;
        this.pageCount = this.calPageCount(this.mapFilterList.length);
      });
      this.setPagingDefault();
    },
    mapList() {
      if (this.search === '') {
        this.pageCount = Math.floor(this.mapListSource.length / this.itemsPerPage) + 1;
        this.pageCount = this.calPageCount(this.mapListSource.length);
      } else {
        this.pageCount = Math.floor(this.mapFilterList.length / this.itemsPerPage) + 1;
        this.pageCount = this.calPageCount(this.mapFilterList.length);
      }
      this.setPagingDefault();
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    openScannerResetVersion(item) {
      Store.commit('map/scannerList', []);
      this.openScannerVersion(item);
    },
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString =
        side === 'from' ? this.masterSearchItems.init.FR_DAT : this.masterSearchItems.init.TO_DAT;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from'
          ? (this.masterSearchItems.init.FR_DAT = dateString)
          : (this.masterSearchItems.init.TO_DAT = dateString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT;
        }
      }
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.setDataPaging();
    },
    rowClick(rowIndex, rowData) {
      this.listFrozen.map((e) => {
        $('.v-table-rightview .v-table-row').removeClass('custom-row-click-v-table');
        $('.v-table-rightview .v-table-row:eq(' + rowIndex + ')').addClass(
          'custom-row-click-v-table',
        );
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
      this.rowCurrentClick = rowIndex;
      this.rowKey = rowData.MAP_PRCS_NO;
    },
    rowEnter(rowIndex) {
      this.listFrozen.map((e) => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
    },
    rowLeave(rowIndex) {
      if (this.rowCurrentClick !== rowIndex) {
        this.listFrozen.map((e) => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        });
      }
    },
    calPageCount(data) {
      let page = 1;
      if (data % this.itemsPerPage === 0) {
        page = data / this.itemsPerPage;
      } else {
        page = Math.floor(data / this.itemsPerPage) + 1;
      }
      return page;
    },
    getTableData() {
      this.pageCount = Math.floor(this.mapListSource.length / this.itemsPerPage) + 1;
      this.pageCount = this.calPageCount(this.mapListSource.length);
      Store.commit('map/setDataPaging', { page: this.page, item: this.itemsPerPage });
    },
    pageSizeChange(pageSize) {
      this.pageCount = Math.floor(this.mapPagingList.length / this.itemsPerPage) + 1;
      this.pageCount = this.calPageCount(this.mapPagingList.length);
      this.setPagingDefault();
      Store.commit('map/SET_DATA_PER_PAGE', { page: this.page, item: this.itemsPerPage });
    },
    setDataPaging() {
      this.listFrozen.map((e) => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
      });
      Store.commit('map/SET_DATA_PER_PAGE', { page: this.page, item: this.itemsPerPage });
    },
    setPagingDefault() {
      if (this.page > this.pageCount) {
        this.page = 1;
      }
    },
    sortChange(data) {
      this.dataSort = data;
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        if (sort) {
          Store.commit('map/sortMapList', { col, sort });
          this.setVisibilitySortIcon(col, sort);
          Store.commit('map/setDataPaging', {
            page: this.page,
            item: this.itemsPerPage,
            mapTypeList: 'sort',
          });
          this.$refs.srm_list_table.clearCurrentRow();
          this.columns.map((e) => {
            $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
          });
          let index = this.mapList.findIndex((e) => e.MAP_PRCS_NO === this.rowKey);
          if (index > -1) {
            this.rowCurrentClick = index;
            this.columns.map((e) => {
              $('#' + e.field + index).addClass('custom-row-click-v-table');
            });
          }
        }
      }
    },
    changeDtTp() {
      if (
        this.masterSearchItems.init.DAT_TYPE == undefined ||
        this.masterSearchItems.init.DAT_TYPE == null ||
        this.masterSearchItems.init.DAT_TYPE == ''
      ) {
        this.masterSearchItems.init.FR_DAT = '';
        this.masterSearchItems.init.TO_DAT = '';
      } else {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT || beforeOneMonth();
        this.masterSearchItems.init.TO_DAT =
          this.masterSearchItems.init.TO_DAT || getAppliedTimeZone();
      }
    },
    getBizCode() {
      this.bizCodeSearchItems.data[0].SVC_DIR = '';
      Store.dispatch('common/getBizCode', this.bizCodeSearchItems).then(() => {
        console.log('--------- Finished to process biz ----------');
        for (let i = 0; i < this.bizCodeList.length; i++) {
          let bizObj = {};
          bizObj.text = this.bizCodeList[i].SVC_NAME;
          bizObj.value = this.bizCodeList[i].SVC_ID;
          this.bizItem.push(bizObj);
        }
      });
    },
    getCode() {
      this.codeSearchItems.data[0].GRP_CODE = 'B03';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        console.log('--------- Finished to process code List ----------');
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.codeItem.push(codeObj);
        }
      });
    },
    queryList() {
      this.isLoading = true;
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.FR_DAT,
        );
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.TO_DAT,
        );
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
        this.masterSearchItems.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        Store.dispatch('map/queryList', this.masterSearchItems)
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.$refs.SearchCondition.dialog = true;
        this.isLoading = true;
      }
    },
    showSRMList(exData, e) {
      console.log(e);
      let left = e.clientX;
      if (this.overlay === true) {
        this.overlay = false;
      } else {
        let listResult = [];
        listResult = this.appliedList.filter((item) => {
          if (item.MAP_PRCS_NO === exData.MAP_PRCS_NO) {
            return true;
          }
          return false;
        });
        this.srmData = listResult;
        let top = e.clientY + 20;
        $('.tableOverlay').css('top', top);
        $('.tableOverlay').css('left', left);
        this.overlay = true;
      }
    },
    closeTbOverlay() {
      this.overlay = false;
    },
    releaseLockedMap(item, type) {
      let isCheckedOut = this.getIsCheckedOut(item, type);
      if (isCheckedOut && type === 'MAPP') {
        this.$refs.warningCheckedOutMapperDialog.dialog = true;
        return;
      }
      if (isCheckedOut && type === 'SCAN') {
        this.$refs.warningCheckedOutScannerDialog.dialog = true;
        return;
      }
      this.releaseLockItems.data[0].MAP_KIND = type;
      this.releaseLockItems.data[0].MAP_PRCS_NO = item.MAP_PRCS_NO;
      Store.dispatch('map/updateLock', this.releaseLockItems).then(() => {
        this.queryList();
      });
    },
    onFilterFlatFile(str) {
      this.$refs.srm_list_table.clearCurrentRow();
      this.rowCurrentClick = -1;
      Store.commit('map/SET_MAP_FILTER_PAGE', { filter: this.searchBy, str: this.search });
      Store.commit('map/setDataPaging', {
        page: this.page,
        item: this.itemsPerPage,
        mapTypeList: 'filter',
      });
    },
    deleteMap() {
      if (this.selectMasterRows.length === 0) {
        this.$refs.warningDialog.dialog = true;
      }
      if (this.selectMasterRows.length > 0) {
        this.$refs.deleteDialog.dialog = true;
      }
    },
    onDeleteMap(item) {
      if (item) this.selectMasterRows.push(item);
      if (this.selectMasterRows.length > 0) {
        for (var i = 0; i < this.selectMasterRows.length; i++) {
          this.deleteDataParams.data[i] = {
            MAP_PRCS_NO: `${this.selectMasterRows[i].MAP_PRCS_NO}`,
          };
        }
        Store.dispatch('map/deleteMap', this.deleteDataParams).then(() => {
          this.$refs.deleteSuccesssDialog.dialog = true;
        });
      }
      this.selectMasterRows = [];
    },
    cancelDeleteMap() {
      this.selectMasterRows = [];
    },
    openMapperVersion(itemRow) {
      let isCheckedOut = this.getIsCheckedOut(itemRow, 'MAPP');
      itemRow.isCheckedOut = isCheckedOut;
      let type = 'mapperVersion';
      let item = {
        ROWID: 0,
        data: itemRow,
      };
      this.flatFileVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('mapperVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScannerVersion(itemRow) {
      let isCheckedOut = this.getIsCheckedOut(itemRow, 'SCAN');
      itemRow.isCheckedOut = isCheckedOut;
      let type = 'scannerVersion';
      let item = {
        ROWID: 0,
        data: itemRow,
      };
      this.flatFileVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog('scannerVersion_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScannerLayoutCheckIn() {
      let type = 'scannerCheckIn';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('scannerCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openFlatFileLayoutCheckIn(data) {
      let type = 'mapperCheckIn';
      let item = {
        ROWID: 0,
        data: data,
      };
      let indexArrDialog = this.findDialog('mapperCheckIn_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openModifyMapDialog(rowItem) {
      let type = 'addMapLayout';
      let item = {
        ROWID: 0,
        action: 'modify',
        data: rowItem,
        codeItem: this.codeItem,
      };
      let indexArrDialog = this.findDialog('addMapLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddMapDialog() {
      let type = 'addMapLayout';
      let item = {
        ROWID: 0,
        action: 'add',
        codeItem: this.codeItem,
      };
      let indexArrDialog = this.findDialog('addMapLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openFlatFileLayoutList(rowItem) {
      let type = 'flatFileLayoutList';
      this.flatFileName = rowItem;
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('flatFileLayoutList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMappingDefinitionList(rowItem) {
      let type = 'mappingDefinitionList';
      this.mappingDefinitionFileName = rowItem;
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('mappingDefinitionList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openLoadFile(data) {
      this.prs = {
        CUST_ID: 'cyberlogitec.com',
        STR_SNDR: 'NDAL',
        STR_RCVR: 'CTCT',
        MSG_ID: 'COPARN',
        MSG_VER: 'UND95B',
        DAT_TYPE: 'UPDT',
        FR_DAT: '20200615',
        TO_DAT: '20200715',
        MSG_CNT: null,
        FFL_FILE_NAME: null,
        MAP_NAME: 'test_add_file_modify',
        MAP_CONV_TP: 'F2E',
        FFL_FRMT_TP: null,
        PRCS_STS: 'REPO',
        LAY_PRCS_NO: 'R000000152',
        SRM_PRCS_NO: 'REP0000085',
        ALIAS: '',
        ROWID: 29,
      };
      let type = 'loadFile';
      let item = {
        ROWID: 0,
        data,
        loadFrom: 'map',
      };
      let indexArrDialog = this.findDialog('loadFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openCodeTableDialog(codeCtg) {
      let type = 'selectCodeList';
      let item = {
        ROWID: 0,
        codeCtg: codeCtg,
      };
      let indexArrDialog = this.findDialog('selectCodeList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    loadFlatFile(item) {
      this.flatFileName = item.FFL_FILE_NAME;
      this.flatFile = item;
      this.$refs.addMapLayout[0].updateFlatFile(item);
    },
    loadMappingDefinitionFile(item) {
      this.mappingDefinitionFileName = item.MPD_FILE_NAME;
      this.$refs.addMapLayout[0].updateMapDefinitionFile(item);
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    selectCodeItem(item) {
      let listOb = Object.keys(this.$refs);
      if (listOb.includes('mapperCheckIn') && this.$refs.mapperCheckIn.length > 0) {
        this.$refs.mapperCheckIn[0].updateSelectCodeTitle(item);
      } else if (listOb.includes('addMapLayout') && this.$refs.addMapLayout.length > 0) {
        this.$refs.addMapLayout[0].updateSelectCodeTitle(item);
      }
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    deleteMapper(item) {
      let self = this;
      if (cfg.isDlb) {
        self.selectMasterRows.push(item);
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', { type: 'Mapper', value: item.MAP_PRCS_NO })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
              this.selectMasterRows = [];
            } else {
              self.selectMasterRows.push(item);
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    openVersionHistory(versionList, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = versionList;
      item.comNm = val.MAP_NAME;
      item.item = val;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    setVisibilitySortIcon(colName, sort) {
      let classVisible = `.repo-list-table .v-table-header .${colName} .v-table-sort-icon`;
      $(classVisible).css('visibility', 'visible');
      if (sort === 'reset') {
        $(classVisible).removeAttr('style');
      }
    },
    getIsCheckedOut(itemRow, type) {
      let isCheckedOut = false;
      this.currentUserId = $cookies.get('user-id');
      this.updateUserId = itemRow.MAP_UPD_USR;
      let isLocked;

      if (type === 'MAPP') {
        isLocked = itemRow.MAP_MAPP_CHKIN_YN === 'Y' ? true : false;
      } else {
        isLocked = itemRow.MAP_SCAN_CHKIN_YN === 'Y' ? true : false;
      }

      if (this.currentUserId !== this.updateUserId && isLocked) {
        isCheckedOut = true;
      }
      return isCheckedOut;
    },
  },
  created() {
    // By April to Show EDI Asset depending on Authority.
    // Check whether entered from repository menu on top selection of customer or User menu
    if (this.repomenuMode) {
      // Repository Menu
      if ($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY';
      // CLT Super Provider
      else this.ACCESS_REPO_YN = 'YN'; // Normal User Admin
    } else {
      // Normal User
      this.ACCESS_REPO_YN = 'NN';
    }
    this.tooltipWidth = cfg.tooltipWidth;
    this.dateTimeFormat = config.dateTimeFormat;
    this.changeDtTp();
    this.queryList();
    this.getBizCode();
    this.getCode();
    EventBus.$on('delete-item', this.onDeleteMap);
    this.isCreated = true;
    Store.commit('map/RESET_FILTER_AND_SORT');
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      self.tableHeight = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      self.tableHeight = resizeTableHeight(arrClassMinus, arrClassPlus, true);
    });
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.headers);
    });
    $('body').click((event) => {
      this.closeTbOverlay();
    });
  },
  beforeDestroy() {
    $('body').unbind('click');
  },
};
</script>

<style>
.srm-list-overlay-table .srmDialogHeader {
  color: black !important;
  font-size: 10px !important;
  line-height: 14px;
  text-align: center !important;
}
.srmOverlay {
  bottom: 83px;
  right: 15px;
  top: unset;
  left: unset;
  height: 94px;
  width: 300px;
}
.srmOverlay .v-overlay__content {
  position: absolute;
  top: 0;
}
.srm-list-overlay-table {
  background-color: #ffffff !important;
  color: black !important;
  height: auto;
  width: 300px;
  overflow-x: hidden;
}
.srm-list-overlay-table > div.v-data-table__wrapper > table {
  border-collapse: separate;
}
.srm-list-overlay-table td.sender-col,
.srm-list-overlay-table td.receiver-col,
.srm-list-overlay-table td.message-col {
  font-size: 10px !important;
  line-height: 14px !important;
  border: 1px solid #d0d4dd;
  text-align: center !important;
}
.srmOverlay .v-overlay__scrim {
  opacity: 0 !important;
}
.mapper-version {
  width: 880px !important;
}
.mdi:after,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 'Material Design Icons';
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
}
.map-manager-list-table .locked-col {
  text-align: center;
}
.map-manager-list-table .layout-name-col {
  color: #0082ba;
  font-weight: bold;
}
.map-manager-list-table .csv-file-col {
  color: #0082ba;
  font-weight: bold;
  text-align: left;
}
.map-manager-list-table .business-name-col {
  text-align: left;
  color: #18236d;
  font-weight: bold;
}
.map-manager-list-table .type-col {
  text-align: left;
}
.map-manager-list-table .version-col {
  text-align: center;
  color: #0082ba;
  text-decoration: underline;
  font-weight: bold;
}
.map-manager-list-table .update-user-col {
  text-align: left;
}
.map-manager-list-table .customer-col {
  text-align: left;
}
.map-manager-list-table .selected-row {
  background: #eaf1f8 !important;
}
.map-manager-list-table thead tr th.text-start {
  color: rgb(255, 255, 255) !important;
  border-right: 1px solid #e0e6f2;
  text-align: center !important;
}
</style>
